import React, {useCallback, useEffect, useState} from "react";
import {APIv1} from "../../api";
import {Table} from "antd";
import {useOutletContext} from "react-router-dom";
import {extractDateBySecond} from "../../utils";
import ProductsColumns from "./products.constants";
import {useTranslation} from "react-i18next";
import currencyFormatted from "../../utils/baseFormatter";
import useUrlTableState from "../../hooks/useUrlTableState";
import ListStateIndicator from "../../components/ListStateIndicator/ListStateIndicator";

const Products = (props) => {
    let orderId = props.orderId !== undefined ? props.orderId : null;

    const {t} = useTranslation();
    const columns = ProductsColumns(t);
    const [userData, setUserData] = useState({});
    const [ordersData, setOrdersData] = useState([])
    const [loading, setLoading] = useState(true)
    const {searchText} = useOutletContext()
    const tableState = useUrlTableState({
        searchText,
        includePagination: false,
    });
    const controlledColumns = tableState.controlledColumns(columns);

    const fetchOrdersData = useCallback(async (search = '', ordering = '') => {
        setLoading(true);
        try {
            const response = await APIv1.get(`/order/related/products/${orderId}/`, {
                params: {
                    search,
                    ordering
                },
                headers: {
                    Authorization: `Token ${userData.token}`,
                }
            });

            const data = response.data.map((item) => ({
                key: item.id,
                name: item.name,
                barcode: item.barcode === "" ? '-' : item.barcode,
                amount: item.amount / 1000,
                product_price: currencyFormatted(item.product_price / 100),
                price: currencyFormatted(item.price / 100),
                vat: currencyFormatted(item.vat / 100),
                discount_percent: item.discount_percent,
                created_date: extractDateBySecond(item.created_date),
            }));
            setOrdersData(data)
        } catch (err) {
            console.error('Something went wrong:', err)
        } finally {
            setLoading(false)
        }
    }, [userData.token, orderId])

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    useEffect(() => {
        if (!userData.token) return;

        fetchOrdersData(tableState.search, tableState.ordering)
    }, [tableState.search, tableState.ordering, userData.token])

    const tableChangeHandler = tableState.handleTableChange(columns);

    return (
        <>
            <div style={{minHeight: "auto"}} className='content_container'>
                <ListStateIndicator items={tableState.stateIndicators} onReset={tableState.resetState} onRemove={tableState.removeState}/>
                <Table
                    columns={controlledColumns}
                    dataSource={ordersData}
                    loading={loading}
                    onChange={tableChangeHandler}
                    sticky={true}
                />
            </div>
        </>
    )
}

export default Products;
